export var UserCategoryVoData;
(function (UserCategoryVoData) {
    UserCategoryVoData["USER"] = "USER";
    UserCategoryVoData["CUSTOMER"] = "CUSTOMER";
    UserCategoryVoData["BOT"] = "BOT";
})(UserCategoryVoData || (UserCategoryVoData = {}));
//# sourceMappingURL=user-category-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/user/user-category-vo-data.js
// module id = 950
// module chunks = 14